import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Stack,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ImageIcon from '@mui/icons-material/Image';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import DescriptionIcon from '@mui/icons-material/Description';

const GupshupCsvHelpAccordionCustom = () => {
    return (
        <Box mt={3}>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <InfoOutlinedIcon />
                        <Typography fontWeight={600}>
                            Requisitos del archivo CSV y plantilla (Personalizado)
                        </Typography>
                    </Stack>
                </AccordionSummary>

                <AccordionDetails>
                    <Stack spacing={2}>
                        {/* CSV */}
                        <Box>
                            <Typography fontWeight={600}>📄 Archivo CSV</Typography>
                            <Typography variant="body2">
                                El archivo debe ser <b>CSV</b> y debe contener:
                                <br />• <b>name</b>: nombre del contacto
                                <br />• <b>phone</b>: número de WhatsApp
                                <br />• <b>file</b>: nombre del archivo a adjuntar
                            </Typography>
                        </Box>

                        {/* File binding info */}
                        <Box>
                            <Typography fontWeight={600}>🔗 Asociación de archivo</Typography>
                            <Typography variant="body2">
                                El valor de <b>file</b> debe coincidir exactamente con el
                                nombre del archivo que vas a cargar (imagen, PDF o video).
                                <br />Por ejemplo: si el archivo se llama <b>promo.jpg</b>, el
                                campo <b>file</b> debe ser <b>promo.jpg</b>.
                            </Typography>
                        </Box>

                        {/* Media */}
                        <Box>
                            <Typography fontWeight={600}>📎 Archivo adjunto (solo uno)</Typography>

                            <Stack spacing={1} mt={1}>
                                <Stack direction="row" spacing={1}>
                                    <ImageIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Imagen</b>: formatos comunes (jpg, png). El nombre debe
                                        coincidir con <b>file</b>.
                                    </Typography>
                                </Stack>

                                <Stack direction="row" spacing={1}>
                                    <VideoLibraryIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Video</b>: formatos compatibles (mp4). El nombre debe
                                        coincidir con <b>file</b>.
                                    </Typography>
                                </Stack>

                                <Stack direction="row" spacing={1} alignItems="flex-start">
                                    <DescriptionIcon fontSize="small" />
                                    <Typography variant="body2">
                                        <b>Documento</b>: PDF u otros permitidos. El nombre debe
                                        coincidir con <b>file</b>.
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Box>

                        {/* Warning */}
                        <Typography variant="body2" color="error">
                            ⚠️ No se pueden combinar imagen, video y documento en el mismo
                            registro. Usa un único archivo por fila.
                        </Typography>
                    </Stack>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default GupshupCsvHelpAccordionCustom;